import { render, staticRenderFns } from "./AppFileDragDrop.vue?vue&type=template&id=6324f31e&scoped=true"
import script from "./AppFileDragDrop.vue?vue&type=script&lang=js"
export * from "./AppFileDragDrop.vue?vue&type=script&lang=js"
import style0 from "./AppFileDragDrop.vue?vue&type=style&index=0&id=6324f31e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6324f31e",
  null
  
)

export default component.exports